module.exports = __webpack_public_path__ + "static/media/collect.b89ecfe0.png";